/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 2
 * API documentations version 2.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetAttachedClaims200Response } from '../model';
// @ts-ignore
import { PushCommitments200Response } from '../model';
// @ts-ignore
import { PushCommitmentsRequest } from '../model';
// @ts-ignore
import { ValueValidationRequest } from '../model';
// @ts-ignore
import { ValueValidationResponse } from '../model';
/**
 * ClaimApi - axios parameter creator
 * @export
 */
export const ClaimApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This retrieves attached claims.
         * @summary Gets attached claims
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachedClaims: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/claim/attached-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This registers commitments for claim values.
         * @summary Push commitments
         * @param {PushCommitmentsRequest} [pushCommitmentsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushCommitments: async (pushCommitmentsRequest?: PushCommitmentsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/private/claim/commitments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = pushCommitmentsRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This validates a claim value based on specific configuration. This API is for remote claim validation in service application input step.
         * @summary Validate claim value
         * @param {string} organizationId The organization who validates the value
         * @param {string} claimName Name of claim to validate
         * @param {ValueValidationRequest} [valueValidationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClaimValue: async (organizationId: string, claimName: string, valueValidationRequest?: ValueValidationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('validateClaimValue', 'organizationId', organizationId)
            // verify required parameter 'claimName' is not null or undefined
            assertParamExists('validateClaimValue', 'claimName', claimName)
            const localVarPath = `/v2/private/organizations/{organization_id}/claims/{claim_name}/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (claimName !== undefined) {
                localVarQueryParameter['claim_name'] = claimName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = valueValidationRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This validates a scope value based on specific configuration. This API is for remote claim validation in service application input step.
         * @summary Validate scope value
         * @param {string} organizationId The organization who validates the value
         * @param {string} scopeName Name of scope to validate
         * @param {ValueValidationRequest} [valueValidationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateScopeValue: async (organizationId: string, scopeName: string, valueValidationRequest?: ValueValidationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('validateScopeValue', 'organizationId', organizationId)
            // verify required parameter 'scopeName' is not null or undefined
            assertParamExists('validateScopeValue', 'scopeName', scopeName)
            const localVarPath = `/v2/private/organizations/{organization_id}/scopes/{scope_name}/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (scopeName !== undefined) {
                localVarQueryParameter['scope_name'] = scopeName;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = valueValidationRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimApi - functional programming interface
 * @export
 */
export const ClaimApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClaimApiAxiosParamCreator(configuration)
    return {
        /**
         * This retrieves attached claims.
         * @summary Gets attached claims
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachedClaims(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAttachedClaims200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachedClaims(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This registers commitments for claim values.
         * @summary Push commitments
         * @param {PushCommitmentsRequest} [pushCommitmentsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pushCommitments(pushCommitmentsRequest?: PushCommitmentsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PushCommitments200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pushCommitments(pushCommitmentsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This validates a claim value based on specific configuration. This API is for remote claim validation in service application input step.
         * @summary Validate claim value
         * @param {string} organizationId The organization who validates the value
         * @param {string} claimName Name of claim to validate
         * @param {ValueValidationRequest} [valueValidationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateClaimValue(organizationId: string, claimName: string, valueValidationRequest?: ValueValidationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValueValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateClaimValue(organizationId, claimName, valueValidationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This validates a scope value based on specific configuration. This API is for remote claim validation in service application input step.
         * @summary Validate scope value
         * @param {string} organizationId The organization who validates the value
         * @param {string} scopeName Name of scope to validate
         * @param {ValueValidationRequest} [valueValidationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateScopeValue(organizationId: string, scopeName: string, valueValidationRequest?: ValueValidationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValueValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateScopeValue(organizationId, scopeName, valueValidationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClaimApi - factory interface
 * @export
 */
export const ClaimApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClaimApiFp(configuration)
    return {
        /**
         * This retrieves attached claims.
         * @summary Gets attached claims
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachedClaims(options?: any): AxiosPromise<GetAttachedClaims200Response> {
            return localVarFp.getAttachedClaims(options).then((request) => request(axios, basePath));
        },
        /**
         * This registers commitments for claim values.
         * @summary Push commitments
         * @param {PushCommitmentsRequest} [pushCommitmentsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushCommitments(pushCommitmentsRequest?: PushCommitmentsRequest, options?: any): AxiosPromise<PushCommitments200Response> {
            return localVarFp.pushCommitments(pushCommitmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This validates a claim value based on specific configuration. This API is for remote claim validation in service application input step.
         * @summary Validate claim value
         * @param {string} organizationId The organization who validates the value
         * @param {string} claimName Name of claim to validate
         * @param {ValueValidationRequest} [valueValidationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateClaimValue(organizationId: string, claimName: string, valueValidationRequest?: ValueValidationRequest, options?: any): AxiosPromise<ValueValidationResponse> {
            return localVarFp.validateClaimValue(organizationId, claimName, valueValidationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This validates a scope value based on specific configuration. This API is for remote claim validation in service application input step.
         * @summary Validate scope value
         * @param {string} organizationId The organization who validates the value
         * @param {string} scopeName Name of scope to validate
         * @param {ValueValidationRequest} [valueValidationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateScopeValue(organizationId: string, scopeName: string, valueValidationRequest?: ValueValidationRequest, options?: any): AxiosPromise<ValueValidationResponse> {
            return localVarFp.validateScopeValue(organizationId, scopeName, valueValidationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClaimApi - interface
 * @export
 * @interface ClaimApi
 */
export interface ClaimApiInterface {
    /**
     * This retrieves attached claims.
     * @summary Gets attached claims
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApiInterface
     */
    getAttachedClaims(options?: AxiosRequestConfig): AxiosPromise<GetAttachedClaims200Response>;

    /**
     * This registers commitments for claim values.
     * @summary Push commitments
     * @param {PushCommitmentsRequest} [pushCommitmentsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApiInterface
     */
    pushCommitments(pushCommitmentsRequest?: PushCommitmentsRequest, options?: AxiosRequestConfig): AxiosPromise<PushCommitments200Response>;

    /**
     * This validates a claim value based on specific configuration. This API is for remote claim validation in service application input step.
     * @summary Validate claim value
     * @param {string} organizationId The organization who validates the value
     * @param {string} claimName Name of claim to validate
     * @param {ValueValidationRequest} [valueValidationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApiInterface
     */
    validateClaimValue(organizationId: string, claimName: string, valueValidationRequest?: ValueValidationRequest, options?: AxiosRequestConfig): AxiosPromise<ValueValidationResponse>;

    /**
     * This validates a scope value based on specific configuration. This API is for remote claim validation in service application input step.
     * @summary Validate scope value
     * @param {string} organizationId The organization who validates the value
     * @param {string} scopeName Name of scope to validate
     * @param {ValueValidationRequest} [valueValidationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApiInterface
     */
    validateScopeValue(organizationId: string, scopeName: string, valueValidationRequest?: ValueValidationRequest, options?: AxiosRequestConfig): AxiosPromise<ValueValidationResponse>;

}

/**
 * ClaimApi - object-oriented interface
 * @export
 * @class ClaimApi
 * @extends {BaseAPI}
 */
export class ClaimApi extends BaseAPI implements ClaimApiInterface {
    /**
     * This retrieves attached claims.
     * @summary Gets attached claims
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApi
     */
    public getAttachedClaims(options?: AxiosRequestConfig) {
        return ClaimApiFp(this.configuration).getAttachedClaims(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This registers commitments for claim values.
     * @summary Push commitments
     * @param {PushCommitmentsRequest} [pushCommitmentsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApi
     */
    public pushCommitments(pushCommitmentsRequest?: PushCommitmentsRequest, options?: AxiosRequestConfig) {
        return ClaimApiFp(this.configuration).pushCommitments(pushCommitmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This validates a claim value based on specific configuration. This API is for remote claim validation in service application input step.
     * @summary Validate claim value
     * @param {string} organizationId The organization who validates the value
     * @param {string} claimName Name of claim to validate
     * @param {ValueValidationRequest} [valueValidationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApi
     */
    public validateClaimValue(organizationId: string, claimName: string, valueValidationRequest?: ValueValidationRequest, options?: AxiosRequestConfig) {
        return ClaimApiFp(this.configuration).validateClaimValue(organizationId, claimName, valueValidationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This validates a scope value based on specific configuration. This API is for remote claim validation in service application input step.
     * @summary Validate scope value
     * @param {string} organizationId The organization who validates the value
     * @param {string} scopeName Name of scope to validate
     * @param {ValueValidationRequest} [valueValidationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApi
     */
    public validateScopeValue(organizationId: string, scopeName: string, valueValidationRequest?: ValueValidationRequest, options?: AxiosRequestConfig) {
        return ClaimApiFp(this.configuration).validateScopeValue(organizationId, scopeName, valueValidationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
